// eslint-disable-next-line no-unused-vars
const analyticsTypes = require('../jsdoc-types');

const {
  StorageFactory,
  STORAGE_BACKEND,
  StorageDecorators,
} = require('../../common/utils/storage');

const decorateWith24HoursTTL = StorageDecorators.ttlDecorator.create(
  24 * 60 * 60 * 1000
);

const searchDataStorage = StorageFactory.createStorage({
  backend: STORAGE_BACKEND.LOCAL_STORAGE,
  name: 'ga.searchData',
  decorators: [decorateWith24HoursTTL],
});

const searchDataOfCartItemsStorage = StorageFactory.createStorage({
  backend: STORAGE_BACKEND.LOCAL_STORAGE,
  name: 'ga.searchDataOfCartItems',
  decorators: [decorateWith24HoursTTL],
});

module.exports = {
  searchDataOfCartItemsStorage,
  searchDataStorage,
};
